module.exports = __webpack_public_path__ + "static/media/background.d3de5348.jpg";